import React from 'react';
import PropTypes from 'prop-types';
import useStyle from './LoaderStyle';
import Utils from '../../../services/UtilsService';
import { saffronMango } from '../../../constants/Colors';

const Loader = (props) => {
    const {
        width = 100,
        height = 100,
        color = saffronMango,
        transparentBackground = false,
        className = '',
        loaderClassName = '',
        text = null,
    } = props;
    const classes = useStyle({
        width,
        height,
        color,
        transparentBackground,
    });
    const rootClasses = Utils.getClassName([
        classes.showbox,
        className,
    ]);
    const ngLoaderClasses = Utils.getClassName([
        classes.ngLoader,
        loaderClassName,
    ]);

    return (
        <div className={rootClasses}>
            {text && <p className={classes.text}>{text}</p>}
            <div className={ngLoaderClasses}>
                <svg className={classes.ldCircular} viewBox="25 25 50 50">
                    <circle
                        className={classes.ldPath}
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                    />
                </svg>
            </div>
        </div>
    );
};

Loader.propTypes = {
    className: PropTypes.string,
    loaderClassName: PropTypes.string,
    width: PropTypes.number,
    color: PropTypes.string,
    text: PropTypes.string,
    transparentBackground: PropTypes.bool,
};

export default Loader;
